import React from 'react';
import { default as ReactLoader } from 'react-loaders';
import './Loader.scss';

export default function Loader() {
    return (
        <span className="loader" data-testid="loader">
            <ReactLoader type="ball-scale-ripple-multiple" active />
        </span>
    );
}
